const aiTools = require('./ai-tools')

module.exports = {
  ai: {
    ...aiTools,
    /**
     * 優先配對全文相等的字串，若無則會詢問api，回傳相似度最大的選項
     * @example
     * // returns: 2
     * closestOption('發生了什麼事', [
     *   ['你是誰', '你到底是什麼人'],
     *   ['這裡是哪裡', '我在哪裡'],
     *   ['發生了什麼事'],
     *   ['我們在逃跑嗎', '我們在逃離什麼', '有什麼在追我們嗎'],
     *   ['愛麗絲是誰'],
     *   ['我為什麼會在這個地方']
     * ])
     * @param {Array<String[]>} options
     */
    closestOption(options){
      let map = {}
      let counter = 0
      let all = []
      for(let i in options){
        let sublist = options[i]
        for(let text of sublist){
          map[counter] = i
          all.push(text)
          counter += 1
        }
      }
    }
  },
  delay(millisecond){
    return new Promise((resolve)=>{
      setTimeout(resolve, millisecond)
    })
  }
}
